import { AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents } from "@denishussar/html5-game-engine";
import { Container } from "pixi.js";
import { AnimationContents } from "../../AnimationContents";
import { ButtonController, IButtonControllerOptions } from "../Common/ButtonController";
import { TextInput } from "../Common/TextInput";
import { LocalizationContents } from "../LocalizationContents";
import { GameLogic } from "../Logic/GameLogic";
import { AppStateEnum, GameModel } from "../Models/GameModel";
import { SettingsButtonController } from "./Settings/SettingsButton";
import { Backend } from '../Backend';
import { resizeScreen } from "../Utils/Resize";
import { UIEvents } from "../Constants/Events";

export interface INameScreenOptions {

}

export class NameScreenController extends AnimationBaseController {
    $model: GameModel;
    private oldstyle;
    private newstyle;
    private nameInput: TextInput;
    constructor(
        @Inject private options: INameScreenOptions,
        @Inject private gameLogic: GameLogic,
        @Inject private backend: Backend,
        @Inject private modelEvenets: ModelEvents,
    ) {
        super("NameScreenController");
    }

    getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.NAME_SCREEN_JSON,
            libraryName: 'enter_your_name',
            childControllers: {
                button: {
                    instanceName: 'btn_further',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            const name = this.nameInput.text;
                            if (name) {
                                this.gameLogic.setName(name);
                                document.querySelector('html').style.height = this.oldstyle;

                                this.backend.saveState( {name: name})
                                    .then(() => {
                                        this.gameLogic.setState(AppStateEnum.garage);
                                    })
                                    .catch(reject => {
                                        this.modelEvenets.dispatch(this.$model, UIEvents.showError);
                                    })
                            }
                        },
                        hotKey: 'enter',
                    }
                }
            }
        }
    }

    onInitialize() {
        this.generateInput();
        this.setTextByQuery("nickname_txt", LocalizationContents.getText("title_enter_name"));
        this.setTextVerticalAlignByQuery("nickname_txt", "middle");

        this.addChildControllerAsync({
            controller: SettingsButtonController,
            model: this.$model,
        }, false, "settingsButton");
        (this.$childControllers.get("button") as ButtonController).disabled();
        (this.$childControllers.get("button") as ButtonController).gotoAndStop("disabled");
        this.setTextByQuery("btn_further.further_txt", LocalizationContents.getText("button_next"));
        this.setTextVerticalAlignByQuery("btn_further.further_txt", "middle");

        //it tests error msg for user
        //setTimeout(()=>{this.modelEvenets.dispatch(this.$model, UIEvents.showError);}, 1000);
    }



    protected generateInput(): void {
        const nameBox = this.getDisplayObjectByQuery('ui_text_input')[0] as Container;

        this.nameInput = new TextInput('', {
            input: {
                fontSize: '42pt',
                width: `${460}px`,
                fontFamily: 'Lucida Console',
                background: 'none',
                color: '#ffffff',
                textAlign: 'center',
            },
            box: null,
        });
        // this.nameInput.text = "test text";
        this.nameInput.x = 0 - this.nameInput.width / 2;
        this.nameInput.y = 100 - this.nameInput.height;

        nameBox.addChild(this.nameInput as Container);
        const input = this.nameInput.htmlInput as HTMLInputElement;
        input.style.display = "block";

        this.oldstyle = document.querySelector('html').style.height;
        this.newstyle = window.innerHeight + 'px';


        input.addEventListener('focus', () => {
            document.querySelector('html').style.height = this.newstyle;
        });
        input.addEventListener('input', () => {
            if (this.nameInput.text) {
                (this.$childControllers.get("button") as ButtonController).enabled();
                (this.$childControllers.get("button") as ButtonController).gotoAndStop("active");
                this.setTextByQuery("btn_further.further_txt", LocalizationContents.getText("button_next"));
            } else {
                (this.$childControllers.get("button") as ButtonController).disabled();
                (this.$childControllers.get("button") as ButtonController).gotoAndStop("disabled");
                this.setTextByQuery("btn_further.further_txt", LocalizationContents.getText("button_next"));
            }
        });
        input.addEventListener('blur', () => {
            document.querySelector('html').style.height = this.oldstyle;
            if (this.nameInput.text) {
                (this.$childControllers.get("button") as ButtonController).enabled();
                this.setTextByQuery("btn_further.further_txt", LocalizationContents.getText("button_next"));
            }
        });
        input.focus();

    }

    protected onResize(width: number, height: number, scale: number): void {
        resizeScreen(width, height, scale, this);
    }
}
